module.exports = __webpack_public_path__ + "img/perks_G PostseasonAccess.be7fc573.jpg";